/**
 * Lo de compartir, del lado del panel del estudio.
 *
 * Las formas que vienen del servidor ya no están aquí: se generan en
 * `api/types.gen.ts` con los mismos nombres que se usaban a mano —`ShareLink`,
 * `CreatedShareLink`, `ProjectAsset`, `SelectionSummary`—, así que se importan
 * de ahí. En este fichero queda sólo lo que no cruza por la red.
 */

import type { ShareLink } from '../../api/types.gen'

/**
 * El tope del saludo, el mismo que valida la API.
 *
 * 400 caracteres no es un número redondo al azar: es lo que se lee sin hacer
 * scroll en un móvil antes de llegar a las fotos, que es a lo que viene el
 * cliente. Aquí sirve para avisar antes de enviar en vez de después.
 */
export const WELCOME_MAX = 400

export type ShareLinkState = 'activo' | 'revocado' | 'caducado'

export function stateOf(link: ShareLink, now = new Date()): ShareLinkState {
  if (link.revoked_at !== null) return 'revocado'
  if (link.expires_at !== null && new Date(link.expires_at) <= now) return 'caducado'

  return 'activo'
}

/**
 * La dirección que se comparte.
 *
 * Se construye sobre el origen actual porque el portal vive en el dominio del
 * propio estudio: es su marca la que ve el cliente, no la nuestra. Y la ruta es
 * `/g/` y no `/galeria/compartida/` porque este enlace se manda por WhatsApp y
 * a veces se dicta por teléfono.
 */
export function shareUrl(token: string): string {
  return `${window.location.origin}/g/${token}`
}
